
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/faq",
      function () {
        return require("private-next-pages/es/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/faq"])
      });
    }
  